import React from "react";

import ColorControl from "../ui/ColorControl";

export default function HalftoneControls({
  Slider,

  inkColor,
  setInkColor,

  dotSize,
  setDotSize,

  angle,
  setAngle,

  softness,
  setSoftness,
}) {
  return (
    <>
      <ColorControl label="Ink Color" value={inkColor} onChange={setInkColor} />

      <Slider
        label="Dot Size"
        value={dotSize}
        min={2}
        max={32}
        step={0.5}
        display={dotSize.toFixed(1)}
        onChange={setDotSize}
      />

      <Slider
        label="Angle"
        value={angle}
        min={0}
        max={180}
        step={1}
        display={`${angle.toFixed(0)}°`}
        onChange={setAngle}
      />

      <Slider
        label="Softness"
        value={softness}
        min={0}
        max={1}
        step={0.01}
        display={softness.toFixed(2)}
        onChange={setSoftness}
      />
    </>
  );
}
